const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1102 890",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m1370 888 34.31-98.896c10.18-29.351 2.46-61.944-19.81-83.604l-.97-.941a99.968 99.968 0 0 1-29.54-83.764l12.87-105.772c6.67-54.824-32.37-104.675-87.19-111.346-2.8-.34-5.6-.561-8.42-.665L1230 401.5l-84.18-80.357c-28.69-27.382-71.48-33.816-106.95-16.08l-95.322 47.662a99.998 99.998 0 0 1-49.842 10.426l-77.375-3.968c-41.281-2.116-77.892 26.301-86.081 66.817l-12.97 64.166a99.991 99.991 0 0 0-1.735 12.78l-12.163 172.538a65.999 65.999 0 0 1-6.296 23.835l-33.449 69.938a100.004 100.004 0 0 0-6.171 69.793L671 888h699z",
    style: {
      fill: "#c4c4de"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m671 888-89.712 97.381c-26.568 28.839-24.727 73.759 4.113 100.329a70.974 70.974 0 0 0 44.886 18.7l665.493 30.22c39.17 1.78 72.37-28.53 74.15-67.71.05-1.07.07-2.14.07-3.22V888H671z",
    style: {
      fill: "#8b8bb5"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.5 567V245h-27v335.5c0 7.456 6.044 13.5 13.5 13.5h220.22c15.72 0 31.15 4.285 44.62 12.394l50.4 30.344A113.485 113.485 0 0 0 1193.78 653h261.72v-27h-261.72a86.524 86.524 0 0 1-44.62-12.394l-50.4-30.344A113.485 113.485 0 0 0 1040.22 567H833.5z",
    style: {
      fill: "#ff8484",
      fillRule: "nonzero"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337 618h144v49h-144v-49zm-561-59h144v49H776v-49zm22.5-116.5V320H859l-11.5 122.5h-49zm287 106.5 116 55v49c-3.33 12.726-17 18.06-41 16-24-2.06-60.84-11.726-110.5-29l35.5-91z",
    style: {
      fill: "#de6262"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974 654 642 335.5 613 746l354.5-63 6.5-29z",
    style: {
      fill: "#ffeecd"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.036 746.127c70.097-6.162 118.399-109.04 107.886-229.784-10.514-120.744-75.861-213.632-145.958-207.47-70.097 6.162-118.399 109.04-107.886 229.784 10.514 120.744 75.861 213.632 145.958 207.47z",
    style: {
      fill: "#f5cb76",
      fillRule: "nonzero"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729 669.5v18H621v-18h-51v-20h212v20h-53zm-2 0H623v16h104v-16zm-155-2h103v-16H572v16zm105 0h103v-16H677v16zm-30-283H544v16h103v-16zm-50-2h52v20H436v-20h54v-18h107v18zm-55 18v-16H438v16h104zm53-18v-16H492v16h103zm-212 47h212v20H383v-20zm105 18v-16H385v16h103zm2 0h103v-16H490v16z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 2
    },
    d: "M676 715.5h105v18H676zM729 669.5h105v18H729z",
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.966 695c-17.288 28.847-17.288 45.565 0 50.155 17.287 4.589 31.965-9.507 44.034-42.288L954.966 695z",
    style: {
      fill: "#353535"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.5 1048c117.36 0 212.5-11.64 212.5-26s-95.14-26-212.5-26c-117.361 0-212.5 11.64-212.5 26s95.139 26 212.5 26z",
    style: {
      fill: "#353535",
      fillRule: "nonzero"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1232.39 1009.78 22.96 16.23c.16.11.32.23.47.36 2.64 2.26 2.94 6.24.68 8.88a9.902 9.902 0 0 1-11.02 2.83c-25.98-9.73-40.97-16.76-44.98-21.08l-61.5-53.5-78-19.5-5 102c-6.34.56-11.17.89-14.5 1-30 1-54.331 1.37-70.278 1.61-15.994.25-34.791 0-62.036-.83-2.538-.08-7.708-.64-15.509-1.68l10.479-109.359-64.432 65.419a100.06 100.06 0 0 1-16.968 13.81l-58.513 37.82a64.054 64.054 0 0 1-21.986 8.96L623 1087c-1.746-14.21 4.087-27.05 17.5-38.5 11.706-9.99 50.698-16.77 78.5-18.5 2.657-.17 25.562-19 68.713-56.511a43.996 43.996 0 0 0 4.274-4.264l73.662-84.337a97.996 97.996 0 0 1 70.16-33.465L974 850l8.539-38.54h-20.798c-15.464 0-28-12.536-28-28 0-3.077.508-6.133 1.501-9.044l20.73-60.735C965.092 686.96 990.199 669 1018.43 669h13.99c23.74 0 42.99 19.246 42.99 42.986 0 4.972-.87 9.906-2.55 14.583L1026 856.5l126.75 46.391a99.985 99.985 0 0 1 43.71 31.438L1231 977.5c30-1.333 46.33.333 49 5 2.21 3.875 10.06 12.463 23.54 25.76 2.68 2.64 2.7 6.95.06 9.63-.91.93-2.08 1.57-3.35 1.86a25.986 25.986 0 0 1-22.02-5.13l-5.73-4.62c-20.53 1.12-33.53 1.12-39 0-.37-.08-.74-.15-1.11-.22z",
    style: {
      fill: "#ffcdcd",
      fillRule: "nonzero"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951 848.5c9 15.333 24 24 45 26s36.33-3 46-15l106 21.406-44.5 81.594-22.5-3-19.69 87.98L877.054 1060l27.639-121.901-27.639 51.766L800 904.284c33.289-32.727 62.743-52.487 88.361-59.281 25.618-6.793 46.498-5.628 62.639 3.497z",
    style: {
      fill: "#fff9d6"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1060.69 720.384 20.31 4.86c.18 34.502-8.88 49.492-27.18 44.97-9.15-2.261-14.33-7.826-15.54-16.695-7.69 6.275-15.69 7.994-24.01 5.154-16.871-5.758-17.655-22.649-2.35-50.673l49.08 11.703c-.1.228-.21.455-.31.681z",
    style: {
      fill: "#353535"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947 692.967 1090 729c-5.93-5.587-8.76-9.851-8.5-12.793 2.95-33.352-15.56-43.89-53.54-52.136-38.164-8.286-49.81-9.22-66.081 19.074-1.376 2.393-6.335 5.667-14.879 9.822z",
    style: {
      fill: "#3c3ca0",
      fillRule: "nonzero"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m976 682 108.5 29 3-11.5L980 667l-4 15z",
    style: {
      fill: "#26266f"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.5 688c10.77 0 19.5-8.73 19.5-19.5s-8.73-19.5-19.5-19.5-19.5 8.73-19.5 19.5 8.73 19.5 19.5 19.5z",
    style: {
      fill: "#f5cb76",
      fillRule: "nonzero"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.5 683c8.56 0 15.5-6.492 15.5-14.5s-6.94-14.5-15.5-14.5c-8.56 0-15.5 6.492-15.5 14.5s6.94 14.5 15.5 14.5z",
    style: {
      fill: "#ffeecd",
      fillRule: "nonzero"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.331 718.876c-2.118-5.007-5.186-7.376-9.331-7.376v-3c5.174 0 9.105 2.842 11.685 8.294 10.035-5.98 18.462-3.798 24.602 6.434a1.5 1.5 0 1 1-2.573 1.544c-5.497-9.162-12.442-10.691-21.598-4.711l-20.743 35.096 12.161 2.371a1.5 1.5 0 0 1-.574 2.944l-14.247-2.777a1.5 1.5 0 0 1-1.004-2.235l21.622-36.584zM976 733a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm-21-6a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm-6.359 50.666c-4.552-1.242-7.409-5.01-6.382-8.415 1.027-3.405 5.549-5.159 10.101-3.917 4.551 1.242 7.409 5.01 6.382 8.415-1.027 3.405-5.549 5.159-10.101 3.917zm-11.548 13.315a1.5 1.5 0 0 1 2.815 1.038l-3.5 9.5a1.5 1.5 0 0 1-2.815-1.038l3.5-9.5zm6 2a1.5 1.5 0 0 1 2.815 1.038l-3.5 9.5a1.5 1.5 0 0 1-2.815-1.038l3.5-9.5zm6 2a1.5 1.5 0 0 1 2.815 1.038l-3.5 9.5a1.5 1.5 0 0 1-2.815-1.038l3.5-9.5z",
    style: {
      fill: "#353535",
      fillRule: "nonzero"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115 400.5v20H902v-20h20v-20h212v20h-19zm-88 41h107v20h-107v-20zm-243 364v19H676v-19h-53v-20h212v20h-51zm572-254h54v20h-213v-20h-53v-20h212v20zM1277 778h71v20h-107v-19h-71v-20h107v19z",
    style: {
      fill: "#8b8bb5"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 2
    },
    d: "M384 365.5h105v18H384z",
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.468 546.528v9.424h-8.68v7.068h-11.16v-7.068H509v-9.424l30.628-26.908h11.16v26.908h8.68zm-38.44 0h18.6V530.78l-18.6 15.748zm66.774 17.112c-17.236 0-25.42-7.936-25.42-22.382 0-14.384 8.184-22.258 25.42-22.258 17.174 0 25.42 7.936 25.42 22.258 0 14.384-8.246 22.382-25.42 22.382zm0-9.362c9.796 0 14.26-4.898 14.26-13.02 0-8.06-4.464-12.896-14.26-12.896s-14.26 4.774-14.26 12.896c0 8.184 4.464 13.02 14.26 13.02zm79.546-7.75v9.424h-8.68v7.068h-11.16v-7.068H616.88v-9.424l30.628-26.908h11.16v26.908h8.68zm-38.44 0h18.6V530.78l-18.6 15.748z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026 582h9v20h-9v-20zm226 58h9v20h-9v-20z",
    style: {
      fill: "#8b8bb5"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124 1030H962v18.5h-15v-62a7.5 7.5 0 0 1 15 0v28.5h162v-28.5c0-4.142 3.36-7.5 7.5-7.5 4.14 0 7.5 3.358 7.5 7.5v52l-15 2V1030z",
    style: {
      fill: "#ff8484"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.126 1063.05A15.61 15.61 0 0 0 659 1078a1.5 1.5 0 1 0 3 0 12.61 12.61 0 0 1 8.988-12.08l14.943-4.48c.449-.14.809-.47.973-.91.595-1.59 4.751-4.31 12.212-7.66 6.92-3.12 10.795-3.63 15.458-3.04l.636.09c.249.03.44.05.624.07a1.5 1.5 0 1 0 .332-2.98c-.164-.02-.34-.04-.573-.07a18.46 18.46 0 0 0-.639-.08c-5.197-.67-9.63-.08-17.07 3.27-7.535 3.39-11.949 6.14-13.435 8.62l-14.323 4.3z",
    style: {
      fill: "#353535",
      fillRule: "nonzero"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031 767.659c20.28 5.266 32.07 1.333 35.38-11.8 2.52-9.959-2.74-18.176-14.27-15.39-2.45.592-7.16 5.102-14.11 13.531l-7 13.659z",
    style: {
      fill: "#ffcdcd"
    },
    transform: "translate(-379.877 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1248.71 994.486 15.24-2.14a28.495 28.495 0 0 1 22.32 6.424l18.26 15.38c.64.53 1.58.45 2.12-.18.53-.64.45-1.58-.18-2.12l-18.27-15.375a31.487 31.487 0 0 0-24.66-7.1l-15.25 2.14c-.82.115-1.39.873-1.28 1.694.12.82.88 1.392 1.7 1.277zM1009 401.5h-87v-2h106v-19h2v19h85v2h-104v19h-2v-19zm295 151h-106.5c-.55 0-1-.448-1-1s.45-1 1-1h52.5v-19h2v19h104c.55 0 1 .448 1 1s-.45 1-1 1h-50v19h-2v-19zm-63 227c-.55 0-1-.448-1-1s.45-1 1-1h36c.55 0 1 .448 1 1s-.45 1-1 1h-36zm-513 25v-19h2v19h54v2H677v-2h51z",
    style: {
      fill: "#353535",
      fillRule: "nonzero"
    },
    transform: "translate(-379.877 -245)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error-404.0a9bdffedcb419ebcf9a18783d8774c0.svg";
export { ForwardRef as ReactComponent };